import { Component } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { SelectComponent } from '../../../../../shared/select';
import { Lessee, LesseeProviders } from '../../../../../_models';

export class Type {
    id: number;
    value: string;
    constructor(json?: Object) {
        if (json)
            Object.assign(this, json);
    }
    toString(): string {
        return this.value;
    }
}

@Component({
    selector: 'app-lessee-form',
    templateUrl: './lessee-form.component.html',
    styleUrls: ['./lessee-form.component.scss'],
    providers: [LesseeProviders]
})
export class LesseeFormComponent {
    form: FormGroup;
    requests$: Observable<Object>;
    type: Type;
    dateTexts = {
        label: "Fecha de inicio",
        placeholder: ""
    }
    types = [
        new Type({ id: 0, value: 'Física' }),
        new Type({ id: 1, value: 'Moral' })
    ];

    constructor(protected lesseeData: Lessee, protected fb: FormBuilder,
        protected _location: Location, protected _router: Router,
    ) {
        this.form = fb.group({
            'individual_name': ['', Validators.compose([Validators.nullValidator, Validators.minLength(2)])],
            'corporate_name': ['',
                Validators.compose([Validators.nullValidator, Validators.minLength(2)])],
            'email': ['', Validators.compose([Validators.required, Validators.email])],
            'type': ['Física', Validators.compose([Validators.required])],
            'dob': ['', Validators.compose([Validators.nullValidator])],
            'telephone': ['', Validators.compose([Validators.required])],
            'rfc': ['', Validators.compose([Validators.required])]
        });
    }

    dateChanged($event) {
        this.form.controls.dob.setValue($event.string);
    }

    data($event) {

    }

    error(error) {
        console.error(error);
    }

    end() {
        this._router.navigate([`/lessees`])
    }

    back() {
        this._location.back();
    }

    selectType(type) {
        this.form.controls.type.setValue(type.value);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/lessees/lessee-form/lessee-form.component.ts